import { createClient, processLock } from '@supabase/supabase-js';

const supabaseUrl = 'https://gxkzotonrxzoxwiiafrw.supabase.co';
const supabaseAnonKey = 'sb_publishable_U02INkeyVqoA_6YLc1kdFw_93AVgslS';

// Override the default navigatorLock with processLock. The default lock uses
// the browser Web Lock API with `ifAvailable: true`, which means whenever a
// newer request comes in while an older one is holding the auth-token lock,
// the older one's promise is rejected with "Lock ... was released because
// another request stole it". Every concurrent authFetch + every Supabase
// query (.from().select()) that attaches a JWT acquires this lock, so on page
// load the 5+ parallel calls contend and the losers 401. processLock is a
// simple in-memory mutex that queues instead of stealing — the "stolen"
// error class just doesn't exist in that implementation. Session integrity
// is unchanged; the only difference is that competing callers wait instead
// of rejecting.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    lock: processLock,
  },
});

export type { User, Session } from '@supabase/supabase-js';
